// Stored in the format { newName: oldName }
export default {
  "reesewadleymusic": "TheWetMop",
};



// WEBPACK FOOTER //
// ./src/scenes/users/content/Aliases.js